<template>
    <el-card shadow="hover" style="height: 300px;">
        <label slot="header">侧边栏-侧边栏标题-侧边栏文本</label>
        <el-divider content-position="left">j-drawer title="侧边栏" :close.sync="showDrmx"</el-divider>
        <el-divider content-position="left">j-drawer-label type="title" title="基本信息"</el-divider>
        <el-divider content-position="left">j-drawer-label align="right" title="文本"</el-divider>
        <el-button @click="showDrmx = true;DrmxBtn = '1'">单按钮</el-button>
        <el-button @click="showDrmx = true;DrmxBtn = 'n'">多按钮</el-button>
        <j-drawer title="侧边栏" :close.sync="showDrmx">
            <div slot="header" style="padding: 10px;">
                <el-input value="头部插槽" />
            </div>
            <j-drawer-label type="title" title="基本信息" />
            <div style="padding-right: 30px;">
                <j-drawer-label align="right" title="文本">文本文本</j-drawer-label>
                <j-drawer-label align="right" title="空样式"></j-drawer-label>
            </div>
            <div v-if="DrmxBtn === 'n'" slot="footer" style="display: flex; width: 100%;">
                <el-button @click="showDrmx = false">保存</el-button>
                <el-button @click="showDrmx = false">支持多个按钮</el-button>
                <el-button @click="showDrmx = false">支持多个按钮</el-button>
            </div>
            <el-button v-else slot="footer" @click="showDrmx = false">单按钮</el-button>
        </j-drawer>
    </el-card>
</template>

<script>
    import JDrawer from "./JDrawer";
    import JDrawerLabel from "./components/JDrawerLabel";
    export default {
        components: {
            JDrawer,
            JDrawerLabel
        },
        data() {
            return {
                showDrmx: false,
                DrmxBtn: '1',
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
